export default __webpack_public_path__ + "static/media/complementary--one-direction-left--g1.72b7311e.png";